import { loadFeaturesAction } from './features.actions';

// eslint-disable-next-line unicorn/consistent-function-scoping
export const loadFeatures = () => (dispatch) => {
    return new Promise((resolve) => {
        return resolve(dispatch(loadFeaturesAction()));
    });
};
